import Reflux from "reflux";
import { ActionsJobs } from "../../Actions/ActionsJobs/ActionsJobs";
import Actions from "../../Actions";

export default class JobsStore extends Reflux.Store {
  constructor() {
    super();

    this.state = {
      jobs: [],
      loading: false,
      error: null,
      campaignLoadingId: null // Stores the ID of the job that's having a campaign created
    };

    this.listenables = ActionsJobs;
    this.onError = this.onError.bind(this);
  }

  onError(error) {
    this.setState({ error });
  }

  onGetJobs() {
    this.setState({ loading: true });
  }

  onGetJobsCompleted({ payload }) {
    this.setState({ jobs: payload, loading: false });
  }

  onGetJobsFailed({ payload }) {
    Actions.addNotification({
      type: "error",
      message: payload.message
    });
    this.setState({ loading: false });
  }

  onFetchAndSaveJobs() {
    this.setState({ loading: true });
  }

  onFetchAndSaveJobsCompleted({ payload }) {
    const { message, jobs } = payload;
    Actions.addNotification(message);
    this.setState({ jobs, loading: false });
  }

  onFetchAndSaveJobsFailed({ payload }) {
    Actions.addNotification(payload.message, "error");
    this.setState({ loading: false });
  }

  onCreateCampaignBasedOnJob(jobId) {
    Actions.addNotification("Creating campaign process can take around 20 seconds");
    this.setState({ campaignLoadingId: jobId });
  }

  onCreateCampaignBasedOnJobCompleted({ payload }) {
    const { message, job: updatedJob } = payload;
    this.setState({
      jobs: this.state.jobs.map((job) => (job.id === updatedJob.id ? updatedJob : job))
    });
    this.setState({ campaignLoadingId: null });
    Actions.addNotification(message, "success");
  }

  onCreateCampaignBasedOnJobFailed({ payload }) {
    const { message } = payload;
    Actions.addNotification(message, "error");
    this.setState({ campaignLoadingId: null });
  }

  onOpenCampaignBasedOnJob(job) {
    this.setState({ campaignLoadingId: job.id });
  }
}
